<app-table
  [actionColumnWidth]="300"
  [columns]="columns"
  [loading]="loading"
  [value]="beneficiaries"
  filename="MENU.BENEFICIARY">
  @if (isManager()) {
    <ng-template
      (onClick)="createNewBeneficiary()"
      appToolbarButton
      icon="fal fa-plus"
      labelKey="BENEFICIARIES.CREATE_TITLE"></ng-template>
    <ng-template
      (onClick)="deleteBeneficiary($event.row)"
      appActionButton
      displayIf="deletable"
      icon="fal fa-trash"
      labelKey="ACTIONS.DELETE"
      type="danger"></ng-template>
  }
</app-table>
